<a
  [class.contents]="contents()"
  [fragment]="fragment()"
  [queryParamsHandling]="queryParamsHandling()"
  [queryParams]="queryParams()"
  [routerLinkActive]="activeClass()"
  [routerLink]="route() | routerLink: params()">
  @switch (variant()) {
    @case (strictType('hyperlink')) {
      <app-router-link-link-content>
        <ng-container *ngTemplateOutlet="contentRef" />
      </app-router-link-link-content>
    }

    @default {
      <ng-container *ngTemplateOutlet="contentRef" />
    }
  }
</a>

<ng-template #contentRef>
  <ng-content />
</ng-template>
